import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { CustomTitle } from "../Custom/CustomTypography";
import CustomButton from "../Custom/CustomButton";
import CustomTextField from "../Custom/CustomTextField";
import CloseIcon from "@mui/icons-material/Close";

const RequestSubmitPopup = ({
  open,
  handleClose,
  title,
  handleTextFieldChange,
  handleSubmit,
  buttonTitle,
  customFields, // Added prop for custom form fields
  loanId,
  fpoId,
}) => {
  const handleChange = (fieldName, fieldValue) => {
    handleTextFieldChange(fieldName, fieldValue);
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ width: "100%" }}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 20,
          left: 10,
          color: "red",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <CustomTitle>{title}</CustomTitle>
        {customFields.map((field, index) => (
          <CustomTextField
            key={index}
            label={field.label}
            name={field.name}
            value={field.value}
            onChange={handleChange}
            type={field.type}
            required={field.required}
            options={field.options}
            error={field.error}
            helperText={field.helperText}
          />
        ))}
        <CustomButton hideIcon onClick={() => handleSubmit(fpoId, loanId)}>
          {buttonTitle}
        </CustomButton>
      </DialogContent>
    </Dialog>
  );
};

export default RequestSubmitPopup;
